import { useRef } from "react";
import styled from "styled-components";
import { layout, LayoutProps } from "styled-system";
import { useOverlayTriggerState } from "@react-stately/overlays";
import { useButton } from "@react-aria/button";
import { useOverlayTrigger } from "@react-aria/overlays";
import css from "@styled-system/css";

import ResponsiveLayout from "../ResponsiveLayout/ResponsiveLayout";
import Icon from "../Icon/Icon";
import MobileMenu from "./MobileMenu";

import NavItem from "./NavItem";
import { MenuLink } from "../Navigation/MenuLink.type";
import CagLogo from "./CagLogo";

const Header = styled.header`
  ${css({
    fontFamily: "normal",
  })}
`;

const TopLevelNav = styled.ul<LayoutProps>`
  display: flex;
  list-style-type: none;
  ${layout}
`;

const HamburgerButton = styled.button<LayoutProps>`
  background: transparent;
  border: none;
  padding: 0;
  height: 18px;
  margin-right: 10px;
  cursor: pointer;
  ${layout}
`;

const ConstellationHeader = ({ navItems }: { navItems: MenuLink[] }) => {
  const menuButtons = navItems
    .filter((item) => item.isVisible)
    .map((item: MenuLink) => {
      return <NavItem key={item.id} item={item}></NavItem>;
    });

  const state = useOverlayTriggerState({});
  const triggerRef = useRef(null);
  const overlayRef = useRef(null);

  let { triggerProps, overlayProps } = useOverlayTrigger(
    { type: "dialog" },
    state,
    triggerRef
  );

  let { buttonProps } = useButton(
    {
      onPress: () => state.open(),
    },
    triggerRef
  );

  return (
    <Header>
      {state.isOpen && (
        <MobileMenu
          navItems={navItems}
          onClose={state.close}
          isOpen={state.isOpen}
          ref={overlayRef}
          {...overlayProps}
        ></MobileMenu>
      )}

      <ResponsiveLayout
        height={{ default: "76px", desktop: "96px" }}
        as="nav"
        role="navigation"
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        backgroundColor="background-default-color"
      >
        <CagLogo />
        <HamburgerButton
          {...buttonProps}
          {...triggerProps}
          ref={triggerRef}
          display={{ _: "initial", desktop: "none" }}
        >
          <Icon
            name="bars"
            weight="regular"
            color="cag12"
            height={18}
            width={18}
          />
        </HamburgerButton>

        <TopLevelNav display={{ _: "none", desktop: "flex" }}>
          {menuButtons}
        </TopLevelNav>
      </ResponsiveLayout>
    </Header>
  );
};

export default ConstellationHeader;
